import { render, staticRenderFns } from "./IdentifyWizard.vue?vue&type=template&id=69f586f3&"
import script from "./IdentifyWizard.vue?vue&type=script&lang=ts&"
export * from "./IdentifyWizard.vue?vue&type=script&lang=ts&"
import style0 from "./IdentifyWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports